import { usePersistedJSON } from 'src/hooks/usePersistedJSON';

import { displayModeStorageKey } from './displayModeStorageKey';

/** 未割当リストの表示単位。伝票 1 件ごとか、積地→降地のレーンごとに畳むか */
export type UnassignedDisplayMode = 'invoice' | 'lane';

export const isUnassignedDisplayMode = (parsed: unknown): parsed is UnassignedDisplayMode => (
  parsed === 'invoice' || parsed === 'lane'
);

/**
 * 表示単位を画面ごとの localStorage キーで持つ。
 *
 * 表示設定（表示項目）の Popover にトグルを置く画面（カード配車・長距離）は、Popover を
 * 描くツールバーと値を見せる未割当リストが別のコンポーネントなので、Presenter がこれを
 * 呼んで両方へ配る。「全選択」行にトグルを置く `/map` は未割当リストの中で完結する。
 *
 * Why not 画面ごとに usePersistedJSON を 2 回呼んで同じキーを共有する: usePersistedJSON は
 * 初回 render の遅延初期化でしか localStorage を読まないので、片方が書いてももう片方の
 * state は更新されない（押しても一覧の見え方が変わらない）。持ち主は 1 つに決める。
 */
export function useUnassignedDisplayMode(screenName: string) {
  return usePersistedJSON<UnassignedDisplayMode>(
    displayModeStorageKey(screenName),
    'invoice',
    isUnassignedDisplayMode,
  );
}
